import { jsxs as P, jsx as n } from "react/jsx-runtime";
import B, { useCallback as j } from "react";
import { Slottable as k, Slot as z } from "../../node_modules/@radix-ui/react-slot/dist/index.es.js";
import L from "../spinner/Spinner.es.js";
import { getStyleProps as R } from "../utils.es.js";
import { rootStyles as T, unstyledButtonStyles as _, labelStyles as D, loaderStyles as V, iconStyles as m } from "./Button.styles.es.js";
import { buttonVariants as M } from "./Button.styles.es.js";
const W = {
  root: T,
  unstyled: _,
  label: D,
  loader: V,
  startIcon: m,
  endIcon: m
}, $ = (u) => {
  const [o, y] = R(u, W, "root"), {
    asChild: l = !1,
    tabIndex: b = 0,
    startIcon: i,
    endIcon: a,
    size: d = "small",
    variant: s = "primary",
    borderRadius: f = "small",
    isLoading: t = !1,
    isDisabled: e = !1,
    inactiveWhenLoading: c = !0,
    onClick: r,
    ref: S,
    children: h,
    unstyled: p,
    ...I
  } = y, v = l ? z : "button", x = s === "tertiary" || s === "tertiaryTransparent", g = j((C) => {
    (!t || !c) && (r == null || r(C));
  }, [c, t, r]);
  return /* @__PURE__ */ P(v, { ...p ? o.unstyled() : o.root({
    variant: s,
    size: d,
    borderRadius: f,
    event: t && !e,
    loader: t && !e && x
  }), ref: S, disabled: e, tabIndex: b, ...!l && {
    type: "button"
  }, onClick: g, ...I, children: [
    i && /* @__PURE__ */ n("span", { ...o.startIcon({
      invisible: t && !e,
      position: "start"
    }), children: i }),
    /* @__PURE__ */ n(k, { children: /* @__PURE__ */ n("span", { ...o.label({
      unstyled: p,
      size: d,
      invisible: t && !e
    }), children: h }) }),
    a && /* @__PURE__ */ n("span", { ...o.endIcon({
      invisible: t && !e,
      position: "end"
    }), children: a }),
    t && !e && /* @__PURE__ */ n(L, { spinnerSize: "small", ...o.loader({
      variant: s
    }) })
  ] });
}, H = B.memo($);
export {
  M as buttonVariants,
  W as classes,
  H as default
};
//# sourceMappingURL=Button.es.js.map
